// Đẩy popup ra ngoài cùng <body> để tránh bị kẹt trong parent có transform/overflow
document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('addon-popup-overlay');
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }
});

(function moveAddonPopupToBody() {
  var overlay = document.getElementById('addon-popup-overlay');
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  } else if (!overlay) {
    // DOM chưa kịp render, thử lại sau khi DOMContentLoaded
    document.addEventListener('DOMContentLoaded', moveAddonPopupToBody);
  }
})();

// --- Add to cart: thêm sản phẩm chính + add-on cùng lúc ---
document.addEventListener('submit', function (e) {
  var form = e.target.closest('form[action^="/cart/add"]');
  var checkbox = document.getElementById('addon-checkbox');
  if (!form || !checkbox || !checkbox.checked) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var formData = new FormData(form);
  var items = [
    {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity') || '1', 10)
    },
    {
      id: checkbox.dataset.variantId,
      quantity: 1
    }
  ];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(function (err) { console.error('Error:', err); });
}, true);

// --- Toggle mờ/đậm theo trạng thái checkbox (dùng delegation, không phụ thuộc thứ tự load) ---
document.addEventListener('change', function (e) {
  var checkbox = e.target.closest('#addon-checkbox');
  if (!checkbox) return;

  var wrapper = checkbox.closest('.product-addon');
  if (!wrapper) return;

  wrapper.classList.toggle('is-active', checkbox.checked);
});

// Đồng bộ trạng thái mờ/đậm ban đầu khi tải trang (phòng trường hợp trình duyệt tự nhớ checkbox đã tick khi Back/Forward)
document.addEventListener('DOMContentLoaded', function () {
  var checkbox = document.getElementById('addon-checkbox');
  var wrapper = document.querySelector('.product-addon');
  if (checkbox && wrapper) {
    wrapper.classList.toggle('is-active', checkbox.checked);
  }
});

// --- Popup mô tả add-on ---
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.addon-info-trigger');
  var closeBtn = e.target.closest('#addon-popup-close');
  var overlay = document.getElementById('addon-popup-overlay');
  if (!overlay) return;

  if (trigger) {
    e.preventDefault(); // chặn label tự tick/bỏ tick checkbox khi bấm vào ảnh/tên/giá
    overlay.classList.add('is-open');
  }

  if (closeBtn || e.target === overlay) {
    overlay.classList.remove('is-open');
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var overlay = document.getElementById('addon-popup-overlay');
    if (overlay) overlay.classList.remove('is-open');
  }
});